import { styled } from "twin.macro";
import React, { forwardRef, HTMLAttributes, RefObject } from "react";
import { AlignItems, Justify } from "../../types";

type Props = {
  children: React.ReactNode;
  direction?: "column" | "row" | "row-reverse";
  justify?: Justify;
  alignItems?: AlignItems;
  alignSelf?: "flex-start" | "flex-end";
  flexWrap?: "wrap" | "nowrap";
  fullWidth?: boolean;
  width?: number;
  variant?: string;
} & HTMLAttributes<HTMLElement>;

/** @deprecated divにtailwindでスタイリングする */
const Grid = forwardRef(({ children, ...rest }: Props, ref: RefObject<any>) => {
  return (
    <Component {...rest} ref={ref}>
      {children}
    </Component>
  );
});

Grid.displayName = "Grid";

const Component = styled.div<Props & { ref: RefObject<any> }>`
  display: flex;
  flex-direction: ${({ direction }) => direction || "column"};
  align-items: ${({ alignItems }) => alignItems || "flex-start"};
  align-self ${(props) => props.alignSelf};
  justify-content: ${({ justify }) => justify || "flex-start"};
  flex-wrap: ${({ flexWrap }) => flexWrap || "nowrap"};
  width: ${({ fullWidth }) => (fullWidth ? "100%" : "auto")};
  width: ${({ width }) => width && `${width}px`};
  text-align: left;
`;

export default Grid;
